



















import { Component, Prop, Vue } from 'vue-property-decorator';
import ProgressBar from '@/components/atoms/ProgressBar.vue';

@Component({
  components: {
    ProgressBar,
  },
})
export default class BuildingCard extends Vue {
  @Prop() title!: string;

  @Prop() icon!: string;

  @Prop() progress!: number | undefined;

  @Prop() total!: number | undefined;

  private get filteredBuildingName(): string {
    return this.title.split('|')[0];
  }

  private get showProgressBar(): boolean {
    return this.progress !== undefined && this.total !== undefined;
  }
}
